<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4425"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4429"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4439"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4437" /></clipPath></defs><g
     id="g4431"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4433"><g
         id="g4435"
         clip-path="url(#clipPath4439)"><g
           id="g4441"
           transform="translate(398.3809,13.4229)"><path
             d="m 0,0 c -19.069,11.396 -34.54,30.614 -46.498,52.895 -12.042,22.45 -18.559,46.147 -18.36,68.484 0.085,9.921 2.323,10.998 10.512,15.42 L 8.642,170.786 71.603,136.799 C 79.82,132.377 82.03,131.3 82.115,121.379 82.313,99.042 75.796,75.345 63.754,52.895 51.825,30.614 36.326,11.396 17.284,0 9.662,-4.563 7.622,-4.563 0,0 Z"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4443" /></g><g
           id="g4445"
           transform="translate(31.5,240.1084)"><path
             d="M 0,0 V 55.785 C 0,70.016 9.549,81.694 21.223,81.694 H 354.3 c 11.674,0 21.223,-11.678 21.223,-25.909 V -55.899 M 332.284,-193.152 H 21.223 C 9.549,-193.152 0,-181.502 0,-167.243 v 77.442"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4447" /></g><g
           id="g4449"
           transform="translate(366.5322,321.8027)"><path
             d="m 0,0 v 32.854 c 0,81.042 -66.275,147.343 -147.285,147.343 -80.981,0 -147.257,-66.301 -147.257,-147.343 V 0"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4451" /></g><g
           id="g4453"
           transform="translate(318.5615,321.8027)"><path
             d="m 0,0 v 32.854 c 0,54.566 -44.798,99.353 -99.314,99.353 -54.517,0 -99.286,-44.815 -99.286,-99.353 V 0"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4455" /></g><g
           id="g4457"
           transform="translate(243.7002,234.9775)"><path
             d="M 0,0 H 89.227"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4459" /></g><g
           id="g4461"
           transform="translate(243.7002,180.9775)"><path
             d="M 0,0 H 61.572"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4463" /></g><g
           id="g4465"
           transform="translate(31.5,195.1514)"><path
             d="M 0,0 V 0.057"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4467" /></g><g
           id="g4469"
           transform="translate(147.7866,264.9961)"><path
             d="M 0,0 C 22.81,0 41.313,-18.51 41.313,-41.329 41.313,-64.147 22.81,-82.657 0,-82.657 c -22.81,0 -41.284,18.51 -41.284,41.328 C -41.284,-18.51 -22.81,0 0,0 Z"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4471" /></g><g
           id="g4473"
           transform="translate(147.7866,103.7627)"><path
             d="m 0,0 h -47.744 c -8.586,0 -15.641,7.029 -15.641,15.647 0,33.958 31.225,62.929 63.385,62.929 32.16,0 63.414,-28.971 63.414,-62.929 C 63.414,7.029 56.358,0 47.745,0 Z"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4475" /></g><g
           id="g4477"
           transform="translate(383.1084,94.9189)"><path
             d="M 0,0 17.199,-16.102 52.873,20.494"
             style="stroke:#000000;stroke-width:20.148;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4479" /></g></g></g></g></svg>
</template>
